module.exports = __webpack_public_path__ + "static/img/qrcode20250429.7072675.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode20250429.jpg
// module id = Jxf5
// module chunks = 19